$(function() {

    $('body').on('click', '#insta-feed > h2', function() {
        window.open('https://www.instagram.com/fryth_made/', '_blank');
        return false;
    });

    $('#Details-menu-drawer-container > summary').on('click', function() {
        $('body').addClass('drawer-menu-opened');
        $('body').addClass('lock-body');

        if ($('cart-drawer').length && $('cart-drawer').hasClass('active')) {
            $('cart-drawer').removeClass('active');
        }

        return false;
    });

    $('#close-menu-drawer').on('click', function() {
        $('body').removeClass('drawer-menu-opened');
        

        setTimeout(() => {
          $('body').removeClass('lock-body');
        }, 600);

        return false;
    });

    if ($('.us-product-media-gallery').length) {

        var galleryThumbs = new Swiper('.us-product-media-gallery .gallery-thumbs', {
            spaceBetween: 10,
            slidesPerView: 6,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: 'vertical'
        });

        var swiper = new Swiper('.us-product-media-gallery .gallery', {
            pagination: {
            el: '.swiper-pagination',
            clickable: true
            },
            thumbs: {
                swiper: galleryThumbs
            },
            on: {
                slideChange: function() {
                    $(this.el).find('.swiper-fraction > .current-slide').text(this.realIndex + 1);
                }
            }
        });
    }

    if ($('.fn-macy-container').length) {

        $('.fn-macy-container').each(function() {

            var max_columns = 2;

            if ($(this).hasClass('3-columns')) {
                max_columns = 3;
            }

            var margin_780 = 60;
            var margin_1024 = 80;
            var margin_1350 = 122;
            var margin_1800 = 200;

            if ($(this).closest('.us-contained-page-content').length) {
                margin_780 = 60;
                margin_1024 = 60;
                margin_1350 = 60;
                margin_1800 = 60;
            }

            var macyInstance = Macy({
                container: $(this)[0],
                waitForImages: false,
                mobileFirst: true,
                columns: 1,
                margin: 50,

                breakAt: {
                    780: {
                        columns: 2,
                        margin: margin_780,
                    },
                    1024: {
                        columns: max_columns,
                        margin: margin_1024
                    },
                    1350: {
                        columns: max_columns,
                        margin: margin_1350
                    },
                    1800: {
                        columns: max_columns,
                        margin: margin_1800
                    },
                }
            });

            macyInstance.runOnImageLoad(function () {
                macyInstance.recalculate(true);
            }, true);

            /*macyInstance.on(macyInstance.constants.EVENT_IMAGE_COMPLETE, function (ctx) {
                macyInstance.recalculate();
            });*/
        });
    }

  var result = window.location.href.includes('form_type=customer');
  if (result) {
    var value = $('.newsletter-form__field-wrapper input');

    if (value && value.length) {
      if ($('#ContactFooter-error').length) {
        $('#ContactFooter-error').remove();
      }
      const add_ele = document.createElement("h3");
      add_ele.innerText = "You have already subscribed!";
      document.querySelector('.newsletter-form__field-wrapper').appendChild(add_ele);
      add_ele.classList.add('newsletter_already_subscribe','newsletter-form__message','form__message');
    }
  }
  
});